function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.04 25.002a52.633 52.633 0 0 0-.04 1.66C4.316 28.133 8.701 29 16 29s11.684-.868 12.999-2.337c-.018-2.628-.244-5.469-.68-8.523a7.159 7.159 0 0 1-.525.268C25.607 19.418 21.82 20 16 20s-9.607-.583-11.794-1.592a7.155 7.155 0 0 1-.525-.268 71.523 71.523 0 0 0-.508 4.564C5.093 24.204 8.706 25 14 25v2c-4.881 0-8.532-.647-10.96-1.998zm-1.037-9.104c.04-.626.442-1.182 1.144-1.663a5.49 5.49 0 0 1 1.9-3.016 5.5 5.5 0 0 1 5.294-6.217A6.004 6.004 0 0 1 21.47 4.53a6.004 6.004 0 0 1 3.476 4.662 5.504 5.504 0 0 1 4.052 5.146c.612.457.962.978.999 1.56.564 3.402.89 6.57.979 9.505.664.467 1.024 1 1.024 1.597 0 2.108-4.49 3.416-10.985 3.844A72.727 72.727 0 0 1 16 31c-1.84 0-3.51-.05-5.015-.156C4.49 30.416 0 29.108 0 27c0-.597.36-1.13 1.024-1.597.088-2.935.415-6.103.98-9.505zm3.195.763C7.109 17.486 10.592 18 16 18c4.712 0 7.964-.39 9.987-1.037a3.5 3.5 0 0 0-2.096-5.942l-.896-.099.005-.9a4.009 4.009 0 0 0-2.638-3.784l-.44-.16-.16-.44a4.002 4.002 0 0 0-7.688.592l-.18.923-.932-.123a3.5 3.5 0 0 0-3.845 4.374l.192.72-.635.39a3.497 3.497 0 0 0-1.476 4.147zm6.75-4.095a1 1 0 0 1-1.897-.632c.851-2.553 3.061-3.437 6.191-2.654a1 1 0 1 1-.485 1.94c-2.202-.55-3.326-.101-3.808 1.346zM16 25h2v2h-2v-2z"
});

var SvgFood = function SvgFood(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "0e40f8466ba7134351a6ffc8f6df7b61.svg";
export { SvgFood as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/food.svg
// module id = null
// module chunks = 